<section class="placeholder">
  <h1>Architecture scaffold</h1>
  <p>This neutral view is reserved for future feature modules.</p>
</section>
